if (!customElements.get('plp-sticky-bar')) {
  class PlpStickyBar extends HTMLElement {
    constructor() {
      super();
      this.sortSelect = this.querySelector('#SortBySticky');
      this.columnProxyButtons = [...this.querySelectorAll('.plp-sticky-bar__col-btn')];
      this.filterButton = this.querySelector('.plp-sticky-bar__filter-btn');
      this.mainSortSelect = null;
      this.mainColButtons = [];
      this._rafId = null;
      this._gridObserver = null;
      this._expectingGridUpdate = false;
      this.onSortChange = this.onSortChange.bind(this);
      this.onColumnClick = this.onColumnClick.bind(this);
      this.onFilterClick = this.onFilterClick.bind(this);
      this.onMainSortChange = this.onMainSortChange.bind(this);
      this.onMainColClick = this.onMainColClick.bind(this);
      this._onScroll = this._onScroll.bind(this);
      this._onFilterInput = this._onFilterInput.bind(this);
    }

    connectedCallback() {
      this.facetsContainer = document.querySelector('.facets-container');

      if (this.facetsContainer) {
        window.addEventListener('scroll', this._onScroll, { passive: true });
        if (document.readyState === 'complete') {
          this._checkVisibility();
        } else {
          window.addEventListener('load', () => this._checkVisibility(), { once: true });
        }
      }

      this.sortSelect?.addEventListener('change', this.onSortChange);
      this.columnProxyButtons.forEach(btn => btn.addEventListener('click', this.onColumnClick));
      this.filterButton?.addEventListener('click', this.onFilterClick);

      if (this.sortSelect) this.sizeSelectToValue(this.sortSelect);

      customElements.whenDefined('collection-user-columns').then(() => {
        this.syncColumnActiveStates();
        const mainColumns = document.querySelector('.plp-toolbar collection-user-columns');
        this.mainColButtons = mainColumns ? [...mainColumns.querySelectorAll('.collection-user-columns__btn')] : [];
        this.mainColButtons.forEach(btn => btn.addEventListener('click', this.onMainColClick));
      });

      this.mainSortSelect = document.querySelector('#SortByDesktop');
      this.mainSortSelect?.addEventListener('change', this.onMainSortChange);

      document.addEventListener('input', this._onFilterInput, { passive: true });

      const grid = document.getElementById('ProductGridContainer');
      if (grid) {
        this._gridObserver = new MutationObserver(() => {
          if (this._expectingGridUpdate && window.scrollY > 0) {
            window.scrollTo({ top: 0, behavior: 'instant' });
          }
          this._expectingGridUpdate = false;
          requestAnimationFrame(() => this._checkVisibility());
        });
        this._gridObserver.observe(grid, { childList: true });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      if (this._rafId) cancelAnimationFrame(this._rafId);
      this._gridObserver?.disconnect();
      document.removeEventListener('input', this._onFilterInput);
      this.sortSelect?.removeEventListener('change', this.onSortChange);
      this.columnProxyButtons.forEach(btn => btn.removeEventListener('click', this.onColumnClick));
      this.filterButton?.removeEventListener('click', this.onFilterClick);
      this.mainSortSelect?.removeEventListener('change', this.onMainSortChange);
      this.mainColButtons.forEach(btn => btn.removeEventListener('click', this.onMainColClick));
    }

    _onScroll() {
      if (this._rafId) return;
      this._rafId = requestAnimationFrame(() => {
        this._checkVisibility();
        this._rafId = null;
      });
    }

    _checkVisibility() {
      if (!this.facetsContainer) return;
      const headerOffset = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-bottom') ||
        getComputedStyle(document.documentElement).getPropertyValue('--header-bottom-pos')
      ) || 0;
      const rect = this.facetsContainer.getBoundingClientRect();
      this.toggleAttribute('hidden', rect.bottom >= headerOffset);
    }

    onSortChange() {
      const mainSelect = document.querySelector('#SortByDesktop');
      const mainForm = document.querySelector('#FacetSortFormDesktop');
      if (!mainSelect || !mainForm) return;
      mainSelect.value = this.sortSelect.value;
      this._expectingGridUpdate = true;
      window.scrollTo({ top: 0, behavior: 'smooth' });
      mainForm.dispatchEvent(new Event('input', { bubbles: true }));
      requestAnimationFrame(() => {
        this.sizeSelectToValue(this.sortSelect);
        this.sizeSelectToValue(mainSelect);
      });
    }

    onMainSortChange() {
      if (!this.sortSelect || !this.mainSortSelect) return;
      this.sortSelect.value = this.mainSortSelect.value;
      requestAnimationFrame(() => this.sizeSelectToValue(this.sortSelect));
    }

    onColumnClick(event) {
      const col = event.currentTarget.getAttribute('attr-col');
      const mainBtn = document.querySelector(`.plp-toolbar collection-user-columns [attr-col="${col}"]`);
      mainBtn?.click();
      requestAnimationFrame(() => this.syncColumnActiveStates());
    }

    onMainColClick() {
      requestAnimationFrame(() => this.syncColumnActiveStates());
    }

    onFilterClick() {
      const savedScrollY = window.scrollY;
      document.querySelector('.mobile-facets__open-wrapper')?.click();
      requestAnimationFrame(() => window.scrollTo({ top: savedScrollY, behavior: 'instant' }));
    }

    _onFilterInput(event) {
      if (event.target.closest('#FacetFiltersFormMobile, #FacetFiltersForm')) {
        this._expectingGridUpdate = true;
      }
    }

    syncColumnActiveStates() {
      const mainColumns = document.querySelector('.plp-toolbar collection-user-columns');
      if (!mainColumns) return;
      this.columnProxyButtons.forEach(proxyBtn => {
        const col = proxyBtn.getAttribute('attr-col');
        const mainBtn = mainColumns.querySelector(`[attr-col="${col}"]`);
        if (!mainBtn) return;
        ['mobile-active', 'tablet-active', 'desktop-active'].forEach(cls => {
          proxyBtn.classList.toggle(cls, mainBtn.classList.contains(cls));
        });
      });
    }

    sizeSelectToValue(select) {
      const span = document.createElement('span');
      const cs = getComputedStyle(select);
      span.style.cssText = `visibility:hidden;position:fixed;white-space:nowrap;top:-9999px;left:-9999px;font-size:${cs.fontSize};font-family:${cs.fontFamily};font-weight:${cs.fontWeight};letter-spacing:${cs.letterSpacing};text-transform:${cs.textTransform};`;
      span.textContent = select.options[select.selectedIndex]?.text || '';
      document.body.appendChild(span);
      select.style.width = (span.offsetWidth + 1) + 'px';
      document.body.removeChild(span);
    }
  }

  customElements.define('plp-sticky-bar', PlpStickyBar);
}
